import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { LinearGradient } from 'react-native-linear-gradient';
import Icon from 'react-native-vector-icons/AntDesign';
import { DbCustomHeaderProps } from './DbCustomHeader.types';

export const DbCustomHeader: React.FC<DbCustomHeaderProps> = ({
    title,
    onBackPress,
    rightComponent,
    variant = 'primary',
    gradientColors: customGradientColors,
    iconColor,
    titleColor,
    gradientProps,
    style,
    textStyle,
}) => {
    // 默认线性渐变颜色
    const defaultGradientColors = {
        primary: ['#fff', '#f0f0f0'],
        secondary: ['#f0f8ff', '#e6e6fa'],
        outline: ['#ffffff', '#ffffff'],
    };

    // 合并渐变颜色
    const gradientColors = customGradientColors || defaultGradientColors[variant];

    return (
        <LinearGradient
            colors={gradientColors}
            style={[styles.gradient, style]}
            {...gradientProps}
        >
            <View style={styles.header}>
                {/* 返回按钮 */}
                <TouchableOpacity onPress={onBackPress} style={styles.backButton}>
                    <Icon name="left" size={20} color={iconColor || '#999'} />
                </TouchableOpacity>

                {/* 标题 */}
                <View style={styles.title_content}>
                    <Text
                        style={[
                            styles.title,
                            { color: titleColor },
                            textStyle,
                        ]}
                    >
                        {title}
                    </Text>
                </View>

                {/* 右侧组件 */}
                <View style={styles.rightComponent}>{rightComponent}</View>
            </View>
        </LinearGradient>
    );
};

const styles = StyleSheet.create({
    gradient: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        paddingHorizontal: 16,
        height: 44,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    title_content: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    backButton: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    rightComponent: {
        width: 20,
    },
});

// 保持向后兼容的别名
export const CustomHeader = DbCustomHeader;

export default DbCustomHeader;
